<template>
  <el-row class="core_one_wrap">
    <el-col class="one_left">
      <div class="left_tit">
        建立了標準化的知識産權服務流程和規範，利用互聯網技術實現案件的智能化管理和案件進度信息的實時自動推送，有效提昇服務效率和透明度，讓客戶隨時了解業務進展
      </div>
      <ul class="left_desc">
        <li>
          首創"知識産權大數據共享經濟"
          運營模式，依託萬知雲知識産權管理系統、萬知共享獨立商城系統、萬知數據交互系統、萬知深度檢索分析服務系統等四大服務體繫，為各類客戶提供全面系統的知識産權資源運營解決方案，以大數據為支撐，精準匹配資源，解決行業資源配置難題。
        </li>
      </ul>
      <div class="left_card_container">
        <div class="card_item" v-for="(item, index) in cardList" :key="index">
          <div @click="changeRouter(index)" class="card_content">
            <!-- 添加了动态光效层 -->
            <div class="card_shine"></div>
            <div class="card_icon_wrapper">
              <i :class="item.icon" class="iconfont"></i>
            </div>
            <el-tooltip
              :content="item.txt"
              :disabled="item.txt.length <= 6"
              placement="top"
            >
              <!-- 使用 line-clamp 替代单行省略，视觉更好 -->
              <span
                class="item_txt"
                :class="{ 'ellipsis-2': item.txt.length > 5 }"
              >
                {{ item.txt }}
              </span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </el-col>
    <el-col class="one_right">
      <img src="@/assets/img/banner/qiehuan1.jpg" alt="" />
    </el-col>
  </el-row>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          icon: "icon-chanyelian-shengwuyiyao",
          txt: "科硏"
        },
        {
          icon: "icon-shengchanzhizao",
          txt: "Science Exploration"
        },
        //暂时将大秦农夫板块去掉
        // {
        //   icon: "icon-zu",
        //   txt: "大秦農夫"
        // },
        {
          icon: "icon-xinnengyuan",
          txt: "商標"
        },
        {
          icon: "icon-dc-icon-xinxijishu",
          txt: "科硏項目申報"
        },
        {
          icon: "icon-jienenghuanbao",
          txt: "版權"
        },
        {
          icon: "icon-shuzichuangyi",
          txt: "專利"
        },
        {
          icon: "icon-fenzishi",
          txt: "科技服務業務"
        }
      ]
    };
  },
  methods: {
    changeRouter(index) {
      switch (index) {
        case 0:
          this.$router.push("/kyDetail").catch(v => {});
          break;
        case 1:
          this.$router.push("/SeDetail").catch(v => {});
          break;
        // case 2:
        //   this.$router.push("/daqin").catch(v => {});
        //   break;
        case 2:
          this.$router.push("/copyrightInfo").catch(v => {});
          break;
        case 3:
          this.$router.push("/projectInfo").catch(v => {});
          break;
        case 4:
          this.$router.push("/rightInfo").catch(v => {});
          break;
        case 5:
          this.$router.push("/patentInfo").catch(v => {});
          break;
        case 6:
          this.$router.push("/serviceInfo").catch(v => {});
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.core_one_wrap {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  margin-bottom: 30px;
  padding: 2rem 0;
  width: 100%;
  max-width: 1920px;
  margin-left: auto;
  margin-right: auto;

  // 超大屏适配
  @media screen and (min-width: 1920px) {
    max-width: 2560px;
    padding: 3rem 0;
  }

  // 大屏适配
  @media screen and (min-width: 1440px) and (max-width: 1919px) {
    max-width: 1600px;
  }

  // 平板和小屏电脑
  @media screen and (max-width: 1024px) {
    flex-direction: column;
    padding: 1.5rem 0;
  }

  // 手机横屏
  @media screen and (max-width: 768px) {
    padding: 1rem 0;
  }

  // 手机竖屏
  @media screen and (max-width: 576px) {
    padding: 0.5rem 0;
  }

  .one_left {
    width: 60%;
    padding: 0 2rem;
    box-sizing: border-box;

    @media screen and (min-width: 1920px) {
      width: 55%;
      padding: 0 3rem;
    }

    @media screen and (max-width: 1024px) {
      width: 100%;
      padding: 0 1.5rem;
    }

    @media screen and (max-width: 768px) {
      width: 100%;
      padding: 0 1rem;
    }

    @media screen and (max-width: 576px) {
      padding: 0 0.75rem;
    }

    .left_tit {
      font-size: 1.4rem;
      font-weight: bold;
      color: #3e3e3e;
      line-height: 1.5;
      word-break: break-word;

      @media screen and (min-width: 1920px) {
        font-size: 1.8rem;
      }

      @media screen and (max-width: 1024px) {
        font-size: 1.2rem;
      }

      @media screen and (max-width: 768px) {
        font-size: 1.1rem;
        margin-top: 1.25rem;
      }

      @media screen and (max-width: 576px) {
        font-size: 1rem;
      }
    }

    .left_desc {
      color: #717171;
      padding: 1.25rem 2.5rem 1.5rem 2.5rem;
      box-sizing: border-box;

      @media screen and (min-width: 1920px) {
        padding: 1.5rem 3rem 2rem 3rem;
        font-size: 1.1rem;
      }

      @media screen and (max-width: 1024px) {
        padding: 1rem 1.5rem;
        font-size: 1rem;
      }

      @media screen and (max-width: 768px) {
        padding: 1rem 0;
        font-size: 0.95rem;
      }

      @media screen and (max-width: 576px) {
        font-size: 0.9rem;
      }

      li {
        line-height: 1.8;
        word-break: break-word;

        @media screen and (min-width: 1920px) {
          line-height: 2;
          font-size: 1.1rem;
        }

        @media screen and (max-width: 1024px) {
          line-height: 1.6;
          font-size: 1rem;
        }

        @media screen and (max-width: 768px) {
          line-height: 1.5;
          font-size: 0.95rem;
        }

        @media screen and (max-width: 576px) {
          font-size: 0.9rem;
        }
      }
    }
  }

  .one_right {
    width: 30%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;

    @media screen and (min-width: 1920px) {
      width: 35%;
    }

    @media screen and (max-width: 1024px) {
      width: 100%;
      margin-top: 1.5rem;
      padding: 0;
    }

    @media screen and (max-width: 768px) {
      width: 100%;
      margin-top: 1rem;
    }

    @media screen and (max-width: 576px) {
      margin-top: 0.75rem;
    }

    img {
      width: 80%;
      max-width: 400px;
      height: auto;
      object-fit: contain;
      margin-top: 2rem;
      transition: all 0.3s ease;

      @media screen and (min-width: 1920px) {
        width: 90%;
        max-width: 600px;
        margin-top: 3rem;
      }

      @media screen and (max-width: 1024px) {
        width: 60%;
        max-width: 350px;
        margin-top: 1rem;
      }

      @media screen and (max-width: 768px) {
        width: 70%;
        max-width: 280px;
      }

      @media screen and (max-width: 576px) {
        width: 80%;
        max-width: 220px;
      }
    }
  }
}
/* 容器布局 */
.left_card_container {
  display: grid;
  /* 响应式网格：最小140px，最大1fr。移动端自动换行，PC端4列 */
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 20px;
  padding: 10px 0;
}

/* 单个卡片项 */
.card_item {
  position: relative;
  border-radius: 16px;
  /* 微光渐变边框 */
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.1),
    rgba(255, 255, 255, 0.03)
  );
  transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

/* 卡片内容区 - 毛玻璃效果 */
.card_content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 16px;
  background: rgba(255, 255, 255, 0.03); /* 半透明背景 */
  backdrop-filter: blur(12px); /* 毛玻璃 */
  -webkit-backdrop-filter: blur(12px);
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
  height: 100%;
  box-sizing: border-box;
}

/* 扫光效果层 */
.card_shine {
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(
    60deg,
    transparent 40%,
    rgba(255, 255, 255, 0.08) 50%,
    transparent 60%
  );
  transform: translateX(-100%);
  transition: transform 0.6s ease-in-out;
  pointer-events: none;
}

/* 图标容器 */
.card_icon_wrapper {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
  border-radius: 12px;
  margin-bottom: 14px;
  box-shadow: 0 4px 12px
    linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
  transition: all 0.4s ease;
}

.card_icon_wrapper .iconfont {
  font-size: 24px;
  color: #fff;
}

/* 文本样式 */
.item_txt {
  font-size: 14px;
  color: #212020;
  text-align: center;
  line-height: 1.4;
  max-width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2; /* 默认显示2行 */
  overflow: hidden;
  word-break: break-all;
}

/* 超过5个字才显示省略的类 */
.ellipsis-2 {
  -webkit-line-clamp: 2;
}

/* ============ 动态交互效果 ============ */

/* 悬浮时：卡片上浮 + 边框发光 */
.card_item:hover {
  transform: translateY(-6px);
  background: linear-gradient(
    135deg,
    rgba(255, 255, 255, 0.15),
    rgba(118, 75, 162, 0.1)
  );
}

.card_item:hover .card_content {
  border-color: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
  box-shadow: 0 8px 30px
    linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
}

/* 悬浮时：触发光影扫过 */
.card_item:hover .card_shine {
  transform: translateX(50%);
}

/* 悬浮时：图标弹跳放大 */
.card_item:hover .card_icon_wrapper {
  transform: scale(1.1) translateY(-2px);
  box-shadow: 0 6px 16px
    linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
}

/* ============ 响应式适配 ============ */

/* 平板及大屏手机：2列 */
@media (max-width: 768px) {
  .left_card_container {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  .card_content {
    padding: 20px 12px;
  }
  .card_icon_wrapper {
    width: 40px;
    height: 40px;
  }
  .card_icon_wrapper .iconfont {
    font-size: 20px;
  }
}

/* 超小屏手机：1列或2列均可，这里保持2列但缩小间距 */
@media (max-width: 375px) {
  .left_card_container {
    gap: 8px;
  }
  .item_txt {
    font-size: 12px;
  }
}

/* PC大屏：强制4列，并放大间距让布局更大气 */
@media (min-width: 1024px) {
  .left_card_container {
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/core_competence/CoreItemOne.vue